import { QueryFeature } from '../../../../config/queryClient';

enum QueryKey {
  PersonalInfo = 'PersonalInfo',
  Trusts = 'Trusts',
  EstatePlanningPersonalInfo = 'EstatePlanningPersonalInfo',
}

export const queryKeys = {
  personalInfo: (clientId: number) => [QueryFeature.Profile, QueryKey.PersonalInfo, clientId],
  trusts: (clientId: number) => [QueryFeature.Profile, QueryKey.Trusts, clientId],
  estatePlanningPersonalInfo: (clientId: number) => [
    QueryFeature.Profile,
    QueryKey.EstatePlanningPersonalInfo,
    clientId,
  ],
};
